import * as React from "react"
import type { SVGProps } from "react"
const SvgTagMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.15 22.43a2 2 0 0 1-1.43-.6l-7.15-7.15q-.3-.3-.43-.66a2 2 0 0 1 0-1.5q.13-.37.43-.67l7.8-7.82q.28-.28.66-.44a2 2 0 0 1 .77-.16h7.18q.83 0 1.4.59.6.59.6 1.4v7.18q0 .3-.09.57a6 6 0 0 0-1.91-.66V5.43h-7.15L4 13.28l7.15 7.15.94-.95q.2 1.12.78 2.06l-.3.29a2 2 0 0 1-1.42.6" />
    <path d="M15.48 10.43q.61 0 1.06-.44.44-.45.44-1.06 0-.63-.44-1.06a1.5 1.5 0 0 0-1.06-.44q-.62 0-1.07.44a1.5 1.5 0 0 0-.43 1.06q0 .63.43 1.06.45.45 1.07.44m2.09 11.84a.6.6 0 0 0 .39.16q.21 0 .36-.16a.6.6 0 0 0 .16-.4v-.13q.8-.15 1.3-.68.5-.52.5-1.24 0-.78-.42-1.25a3 3 0 0 0-1.33-.78 4 4 0 0 1-1.12-.5q-.24-.2-.24-.44 0-.21.2-.35.2-.15.55-.15.18 0 .36.05t.29.17q.28.22.52.29a.7.7 0 0 0 .44 0 .6.6 0 0 0 .37-.38.5.5 0 0 0-.07-.5 2 2 0 0 0-.59-.54 3 3 0 0 0-.76-.3v-.15a.6.6 0 0 0-.15-.4.5.5 0 0 0-.38-.16.54.54 0 0 0-.55.56v.15q-.81.18-1.2.7t-.38 1.07q0 .7.44 1.17.45.45 1.45.8a3 3 0 0 1 .95.43q.28.23.28.51 0 .26-.24.46t-.68.2q-.22 0-.49-.14a1.4 1.4 0 0 1-.46-.42 1 1 0 0 0-.42-.33.7.7 0 0 0-.48 0 .6.6 0 0 0-.4.34.6.6 0 0 0 0 .5q.22.45.65.8.42.33.98.48v.16q0 .25.17.4" />
  </svg>
)
export default SvgTagMoney
